// extracted by mini-css-extract-plugin
export default {"list":"styles__list--TpnvI","animated-item":"styles__animated-item--QBVjo","rank-item":"styles__rank-item--AK7+H"};